module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-becomethenextcreator.d018d4d1.jpg";